import api from 'Core/src/api/index'
// TODO
// Import router using a different strategy
import router from '../../../router'

export default {
  /**
   * Fetch the site. Uses the API to resolve the question data
   */
  LOAD_NEW_SITE: ({ commit, dispatch, state }, { siteId }) => {
    return new Promise((resolve, reject) => {
      return api.fetchSite({ siteId: siteId })
        .then(data => {
          commit('SET_SITE_DATA', { site: data, siteId: siteId })
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * Fetch the survey. Uses the API to resolve the question data
   */
  LOAD_NEW_SURVEY: ({ commit, dispatch, state }, { surveyId }) => {
    return new Promise((resolve, reject) => {
      return api.fetchSurvey({ surveyId: surveyId })
        .then(data => {
          commit('SET_SURVEY_DATA', { survey: data, surveyId: surveyId })
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * Fetch the test results. Uses the API to resolve the question data
   */
  LOAD_TEST_RESULTS: ({ commit, dispatch, state }, { testResultsId }) => {
    return new Promise((resolve, reject) => {
      return api.fetchTestResults({ testResultsId: testResultsId })
        .then(data => {
          commit('SET_TEST_RESULTS_DATA', { data: data })
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * Fetch the profile. Uses the API to resolve the question data
   */
  LOAD_PROFILE_BY_ID: ({ commit, dispatch, state }, { profileId }) => {
    return new Promise((resolve, reject) => {
      return api.fetchProfile({ profileId: profileId })
        .then(data => {
          commit('STORE_USER_PROFILE', { profile: data, profileId: data.sys.id })
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * Restart the form responses/status.
   */
  RESTART_FORM: ({ commit, dispatch, state }) => {
    commit('RESTART_FORM')
  },
  /**
   * Store a response locally.
   */
  STORE_RESPONSE: ({ commit, dispatch, state }, { response }) => {
    var qid = parseInt(router.currentRoute.params.qid, 10)
    commit('STORE_RESPONSE', { qid: qid, response: response })
  },
  THANK_YOU: ({ commit, dispatch, state }) => {
    commit('SET_SURVEY_STATUS', { status: 'sent' })
  },
  /**
   * Submits gathered responses using the api
   */
  SUBMIT_FORM: ({ commit, dispatch, state }) => {
    commit('SET_SURVEY_STATUS', { status: 'submit' })
    return new Promise((resolve, reject) => {
      return api.sendResponse({ responses: state.responses, surveyData: state.survey })
        .then(data => {
          // Now clear responses from local Storage
          console.log(state.responses)
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * Move to the next question if possible
   */
  NEXT_QUESTION: ({ commit, dispatch, state }) => {
    var current = parseInt(state.survey.qid, 10)
    if (current <= state.survey.questionCount - 1) {
      commit('SET_CURRENT', { current: current + 1 })
    } else {
      // Survey was completed
      commit('SET_SURVEY_STATUS', { status: 'submit' })
    }
  },

  CALCULATE_WEIGHTED_QUESTION: ({ commit, dispatch, state }, { formula, selected, options, maxAnswers }) => {
    return new Promise((resolve, reject) => {
      // Create an array to hold the final calculation
      var weighted = [0, 0, 0, 0]
      var weightedMax = []
      var weightedMin = []

      selected.forEach(item => {
        var index = options.indexOf(item)
        // Transform the formula into an array and clean it (remove variable names and empty slots)
        if (index === -1) {
          return
        }
        var arr = formula[index].split(/[,]+/).filter(i => i)
        if (index > -1) {
          weighted.forEach((variable, i) => {
            weighted[i] += parseInt(arr[i], 10)
          })
        }
      })

      // Get the maximum and minimum according to the formula

      // Get an array of formulas, cleaned
      var formulas = []
      formula.forEach(item => {
        var arr = item.split(/[,]+/).filter(i => i)
        formulas.push(arr)
      })

      // Traverse the formulas
      var traverse = [[], [], [], []]
      formulas.forEach((vector, i) => {
        vector.forEach((factor, j) => {
          traverse[j][i] = factor
        })
      })

      // Calculate the maximum as a vector
      // Sort the traversed formulas
      traverse.forEach((trav, index) => {
        trav.sort((a, b) => {
          return parseInt(b, 10) - parseInt(a, 10)
        })
      })
      traverse.forEach((values, i) => {
        for (var j = 0; j < maxAnswers; j++) {
          var wMaxi = parseInt(weightedMax[i] || 0)
          weightedMax[i] = wMaxi + parseInt(values[j], 10) > wMaxi ? wMaxi + parseInt(values[j], 10) : wMaxi
        }
      })

      // Calculate the minimum as a vector
      // Sort the traversed formulas
      traverse.forEach((trav, index) => {
        trav.sort((a, b) => {
          return parseInt(a, 10) - parseInt(b, 10)
        })
      })
      traverse.forEach((values, i) => {
        for (var j = 0; j < maxAnswers; j++) {
          var wMini = parseInt(weightedMin[i] || 0)
          weightedMin[i] = wMini + parseInt(values[j], 10) < wMini ? wMini + parseInt(values[j], 10) : wMini
        }
      })

      return resolve({ weighted, weightedMin, weightedMax })
    })
  }
}
